module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/PhotographicBackground-5fb74cc94fa00bec2903c6a1d40298c2.webp";